import {ButtonBase, Grid, Typography} from "@mui/material";
import TextField from "@mui/material/TextField";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useState } from "react";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Email_Footer = () => {
    const {sCell} = useResponsive()

    const [emailNews, setEmailNews] = useState('');
    const [mensajeEnviado, setMensajeEnviado] = useState('');

    const handleEmailChange = (e) => {
        setEmailNews(e.target.value);
    };

    const validarEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleEmailSubmit = () => {
        if (validarEmail(emailNews)) {
            setMensajeEnviado('¡Correo enviado con éxito!');
            setEmailNews('');
        } else {
            setMensajeEnviado('Por favor, ingresa un correo válido.');
        }

        setTimeout(() => setMensajeEnviado(''), 4000);
    };
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{pb:2}}>
                    <Typography fontSize={16} fontWeight={'500'} sx={{lineHeight: 1.4, color: '#223B59'}}>
                        Suscribete para recibir ideas espacios compactos diseñados por mi
                    </Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    spacing={0.5}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        mt: 1,
                        mb: mensajeEnviado ? 1 : 3,
                        maxWidth: 380,
                        width: '100%',
                        order: { xs: 0, sm: 3, md:0 }
                    }}
                >
                    <Grid container  size={{xs: 9, sm: 10, md: 10}}>
                        <TextField
                            fullWidth
                            placeholder="Email"
                            value={emailNews}
                            onChange={handleEmailChange}
                            variant="outlined"
                            sx={{
                                backgroundColor: '#f3f3f3',
                                borderRadius: '10px',
                                '& input': {
                                    color: '#000',
                                },
                                '& input::placeholder': {
                                    color: '#999',
                                    opacity: 1,
                                },
                                '& fieldset': {
                                    border: 'none',
                                },
                            }}
                            InputProps={{
                                sx: {
                                    pl: 2,
                                    height: 50,
                                },
                            }}
                        />
                    </Grid>

                    <Grid container  size={{xs: 2, sm: 2, md: 2}}>
                        <ButtonBase
                            onClick={handleEmailSubmit}
                            sx={{
                                width: '100%',
                                height: 50,
                                backgroundColor: '#f3f3f3',
                                borderRadius: '10px',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '&:hover': { backgroundColor: '#e0e0e0' },
                            }}
                        >
                            <ArrowForwardIcon sx={{ color: '#666' }} />
                        </ButtonBase>
                    </Grid>
                </Grid>

                {mensajeEnviado && (
                    <Grid item xs={12}>
                        <Typography
                            fontSize={14}
                            fontWeight={400}
                            color={mensajeEnviado.includes("éxito") ? "green" : "red"}
                        >
                            {mensajeEnviado}
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Grid>
    )
}
export default Email_Footer;

